import { RX0003 } from "../rxTypeCode";

export const CLEANUP = "CLEANUP" + RX0003;
export const SET_PAGINATION = "SET_PAGINATION" + RX0003;
export const SET_CURRENCY= "SET_CURRENCY" + RX0003;
export const SET_ALLOWED_CURRENCIES= "SET_ALLOWED_CURRENCIES" + RX0003;
export const TRANSACTIONHISTORY_REQUEST = "TRANSACTIONHISTORY_REQUEST" + RX0003;
export const TRANSACTIONHISTORY_SUCCESS = "TRANSACTIONHISTORY_SUCCESS" + RX0003;
export const TRANSACTIONHISTORY_FAILURE = "TRANSACTIONHISTORY_FAILURE" + RX0003;
export const ALLOWED_CURRENCIES_REQUEST = "ALLOWED_CURRENCIES_REQUEST" + RX0003;
export const ALLOWED_CURRENCIES_SUCCESS = "ALLOWED_CURRENCIES_SUCCESS" + RX0003;
export const ALLOWED_CURRENCIES_FAILURE = "ALLOWED_CURRENCIES_FAILURE" + RX0003;
